import { s as styleFunctionSx, r as react, t as useTheme, h as _objectWithoutPropertiesLoose, j as jsxRuntime, k as _extends, v as createTheme, p as THEME_ID } from './injectIntl-6b03af4d.js';
import { d as styled, b as clsx, a as generateUtilityClasses, C as ClassNameGenerator } from './styled-a7735015.js';
import { e as extendSxProp } from './extendSxProp-f87ff454.js';

const _excluded = ["className", "component"];
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = styled('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(styleFunctionSx);
  const Box = /*#__PURE__*/react.exports.forwardRef(function Box(inProps, ref) {
    const theme = useTheme(defaultTheme);
    const _extendSxProp = extendSxProp(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = _objectWithoutPropertiesLoose(_extendSxProp, _excluded);
    return /*#__PURE__*/jsxRuntime.exports.jsx(BoxRoot, _extends({
      as: component,
      ref: ref,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}

const boxClasses = generateUtilityClasses('MuiBox', ['root']);
const boxClasses$1 = boxClasses;

const defaultTheme = createTheme();
const Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses$1.root,
  generateClassName: ClassNameGenerator.generate
});
const Box$1 = Box;

export { Box$1 as B };

//# sourceMappingURL=Box-7212e630.js.map